import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="mt-20 border-t border-background-200 bg-secondary-50">
      <div className="mx-auto w-full px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-links-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="text-lg font-bold tracking-tight text-foreground-950">USFansLink</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              {t("footer.tagline")}
            </p>
            <p className="mt-4 max-w-sm text-xs text-foreground-500">{t("footer.disclosure")}</p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">{t("footer.explore")}</h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                  {t("footer.navHome")}
                </Link>
              </li>
              <li>
                <Link
                  to="/usfans-spreadsheet-guide"
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("footer.navGuide")}
                </Link>
              </li>
              <li>
                <Link
                  to="/#categories"
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("footer.navCategories")}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-950">{t("footer.resources")}</h4>
            <ul className="mt-4 space-y-2">
              {categories.slice(0, 5).map((c) => (
                <li key={c.key}>
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {t(c.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} USFansLink. {t("footer.rights")}
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="text-sm font-semibold text-primary-700 hover:underline"
          >
            kaspreadsheet.com
          </a>
        </div>
      </div>
    </footer>
  );
}